import TimelineStory from "components/TimelineStory";
import TimelineEvent from "components/TimelineEvent";
import TimelineQuote from "components/TimelineQuote";
import Timeline from "components/Timeline";
import React from "react";
import asset from "helpers/cdn";

function mapTimelineTypes(timelineItem, key) {
  switch (timelineItem.timelineType) {
    case "story":
      return (
        <TimelineStory
          key={key}
          align={timelineItem.align}
          date={timelineItem.date}
          heading={timelineItem.heading}
          type={timelineItem.type}
          image={timelineItem.image ? asset(timelineItem.image) : ""}
          href={timelineItem.href}
          linkText={timelineItem.linkText}
        >
          {timelineItem.content}
        </TimelineStory>
      );
    case "event":
      return (
        <TimelineEvent
          key={key}
          date={timelineItem.date}
          primaryText={timelineItem.primaryText}
          secondaryText={timelineItem.secondaryText}
          type={timelineItem.type}
        />
      );
    case "quote":
      return (
        <TimelineQuote
          key={key}
          align={timelineItem.align}
          annotation={timelineItem.content}
          text={timelineItem.primaryText}
        />
      );
    default:
  }
}

export default ({ items }) => (
  <Timeline>
    {
      items.map((timelineItem, i) => mapTimelineTypes(timelineItem, i))
    }
  </Timeline>
);
